export default {
  vipUpgrade: {
    title: 'Chúc mừng!!',
    message: 'Bạn đã được thăng cấp từ VIP{from} lên VIP{to}',
    subtitle: 'Cảm ơn sự ủng hộ của bạn. Cấp độ mới mang đến\ndịch vụ độc quyền và đặc quyền đặc biệt.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
